import Article from "../Model/Article";
import ArticleCard from "./Components/ArticleCard";

function Articles({inArticles}: {inArticles: Article[]}) {

    function onArticleClicked(url: string) {
        window.open(url, "_blank", "noopener,noreferrer");
    }

    if (inArticles.length === 0) {
        return (
            <div>
                <p>No articles right now. Come back again sometime soon!</p>
            </div>
        );
    }

    return (
       <div className="page_content">
            <h1 className="centered_headers">
                ARTICLES
            </h1>
            {
                inArticles.map((article: Article) => (
                    <div onClick={() => { onArticleClicked(article.url) }}
                         key={article.id}>
                        <ArticleCard
                            id={article.id}
                            key={article.id}
                            title={article.title}
                            date={article.date}
                            url={article.url}
                        />
                    </div>
                ))
            }
            <a href="https://substack.com/@lukaspowers" target="_blank">All Articles</a>
        </div>
    );
}

export default Articles;